import { createContext } from 'react';

const ValidationsContext = createContext();

export default ValidationsContext;